<template>
  <prime-accordion :multiple="true" :activeIndex="[0]" >

    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
          <span>Dettagli</span>&nbsp;<span>{{data.item.info.ragsoc}}</span>
      </template>

      <div v-if="data.item.id">

        <div class="formgrid grid">

          <div class="field col-12 md:col-4">
            <label for="ragsoc">Ragione Sociale</label>
            <prime-input-text 
              id="ragsoc" 
              v-model="data.item.info.ragsoc" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="toponimo">Toponimo</label>
            <prime-input-text 
              id="toponimo" 
              v-model="data.item.info.toponimo" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="ultimo_fatturato">Ultimo Fatturato</label>
            <prime-input-text 
              id="ultimo_fatturato" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="codfis">Codice Fiscale</label>
            <prime-input-text 
              id="codfis" 
              v-model="data.item.info.codfis" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="indirizzo">Indirizzo</label>
            <prime-input-text 
              id="indirizzo" 
              v-model="data.item.info.indirizzo" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="score">Score</label>
            <prime-input-text 
              id="score" 
              v-model="data.item.info.score" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="piva">Partita Iva</label>
            <prime-input-text 
              id="piva" 
              v-model="data.item.info.piva" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="civico">Civico</label>
            <prime-input-text 
              id="civico" 
              v-model="data.item.info.civico" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="pregiudizi">Pregiudizievoli</label>
            <prime-input-text 
              id="pregiudizi" 
              v-model="data.item.info.pregiudizi" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="email">Email</label>
            <prime-input-text 
              id="email" 
              v-model="data.item.info.email" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cap">Cap</label>
            <prime-input-text 
              id="cap" 
              v-model="data.item.info.cap" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full" 
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_pay_mode">Conto Acquisto</label>
            <prime-dropdown 
              id="cod_type_pay_mode" 
              v-model="data.item.info.cod_type_pay_mode" 
              :options="data.metodiPagamento" 
              optionLabel="descrizione" 
              optionValue="id" 
              placeholder="Seleziona..." 
              :filter="true" 
              :disabled="!isInEdit"
              class="inputfield w-full"
              />
          </div>

          <div class="field col-12 md:col-4">
            <label for="cellulare">Cellulare</label>
            <prime-input-text 
              id="cellulare" 
              v-model="data.item.info.cellulare" 
              type="text" 
              :disabled="!isInEdit"
              class="inputfield w-full"  
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_comune">Comune</label>
            <prime-dropdown 
              id="cod_comune" 
              v-model="data.item.info.cod_comune" 
              :options="data.comuni" 
              optionLabel="descrizione" 
              optionValue="id" 
              optionGroupLabel="provincia" 
              optionGroupChildren="items" 
              placeholder="Seleziona..." 
              :filter="true" 
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"></div>

        </div>

        <div class="grid p-jc-end">
          <div 
            class="col-12 text-right"
            v-if="!isInEdit"
          >
            <prime-button 
              icon="pi pi-pencil" 
              class="p-button-rounded p-button-success mr-2" 
              @click="onEditInfo"
            />
          </div>

          <div 
            class="col-12 text-right"
            v-if="isInEdit"
          >
            <prime-button 
              icon="pi pi-times" 
              class="p-button-rounded p-button-danger mr-2" 
              @click="onAbortInfoEdit"
            />
            <prime-button 
              icon="pi pi-check" 
              class="p-button-rounded p-button-success mr-2" 
              @click="onUpdateInfo"
            />
          </div>
        </div>

      </div>

    </prime-accordion-tab>

    
    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span>Estratto Conto ({{currencyFormatter.format( (data.item.pagamenti.saldo !== null)? data.item.pagamenti.saldo: 0 )}})</span>
      </template>
    
      <prime-data-table 
        v-if="data.item.id"

        :paginator="true" 
        :rows="10"
        :rowsPerPageOptions="[10,25,50]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
        currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        
        :value="data.item.pagamenti.fatture" 
        
        responsiveLayout="scroll"
      >
        <prime-column field="partitario" header="Partitario" ></prime-column>
        <prime-column field="numero" header="Numero Fattura" ></prime-column>
        <prime-column field="protocollo" header="Protocollo" ></prime-column>
        <prime-column field="data_emissione" header="Data Emissione" :sortable="true" >
          <template #body="{data}">
            {{ (data.data_emissione !== null)? moment(data.data_emissione).format('DD/MM/YYYY'): '' }}
          </template>
        </prime-column>
        <prime-column field="data_registrazione" header="Data Registrazione" :sortable="true" >
          <template #body="{data}">
            {{ (data.data_registrazione !== null)? moment(data.data_registrazione).format('DD/MM/YYYY'): '' }}
          </template>
        </prime-column>
        <prime-column field="data_pagamento" header="Data Pagamento" :sortable="true" >
          <template #body="{data}">
            {{ (data.data_pagamento !== null)? moment(data.data_pagamento).format('DD/MM/YYYY'): '' }}
          </template>
        </prime-column>
        <prime-column field="stato" header="Stato" ></prime-column>
        <prime-column field="importo" header="Importo Fattura" >
          <template #body="{data}">
            {{currencyFormatter.format( (data.importo !== null)? data.importo: 0 )}}
          </template>
        </prime-column>
        <prime-column field="pagato" header="Importo Pagato" >
          <template #body="{data}">
            {{currencyFormatter.format( (data.pagato !== null)? data.pagato: 0 )}}
          </template>
        </prime-column>
        <prime-column field="saldo" header="Saldo" >
          <template #body="{data}">
            {{currencyFormatter.format( (data.saldo !== null)? data.saldo: 0 )}}
          </template>
        </prime-column>
      </prime-data-table>

    </prime-accordion-tab>

  </prime-accordion>
</template>

<script>
import province from '@/data/province.json'

import FornitoriService from '@/services/ask-management/fornitori-service'
import UtilityService from '@/services/ask-management/utility-service'

import PrimeButton from 'primevue/button'
import PrimeInputText from 'primevue/inputtext'
import PrimeDropdown from 'primevue/dropdown'
import PrimeAccordion from 'primevue/accordion'
import PrimeAccordionTab from 'primevue/accordiontab'
import PrimeDataTable from 'primevue/datatable'
import PrimeColumn from 'primevue/column'

import moment from 'moment'

export default {
  name: 'ViewAskFornitoriDetail',
  components: {
    PrimeButton,
    PrimeInputText,
    PrimeDropdown,
    PrimeAccordion,
    PrimeAccordionTab,
    PrimeDataTable,
    PrimeColumn,
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      route: {
        params: null
      },

      isInEdit: false,
      oldInfo: null,

      data: {
        allegato: {
          path: null,
          tipo: null,
          note: null
        },

        item: {},
        comuni: [],

        tipiAllegato: [],
        tipiMetodiPagamento: [],

      }
    }
  },

  created(){
    this.route.params = this.$route.params
    // console.log(this.route.params)

    this.fornitoriService = new FornitoriService(this.$http, this.$eventBus)
    this.getDettaglioFornitore(this.route.params.id)

    this.utilityService = new UtilityService(this.$http, this.$eventBus)
    this.getComuni()
    this.getTipiAllegato()
    this.getTipiMetodoPagamento()
  },

  methods: {
    getComuni(){
      this.utilityService.getComuni().then((res) => {
        const listProvince = province.reduce((arr, el) => {
          arr[el.sigla] = `${el.regione} - ${el.nome}`

          return arr
        }, [])

        const comuni = res.items.reduce((arr, el) => {
          arr[el.provincia] = arr[el.provincia] || []

          arr[el.provincia].push({
            id: el.id,
            descrizione: `${el.name} (${el.provincia})`,
          })

          return arr
        }, [])

        const listComuni = []
        for (const sigla in comuni) {
          listComuni.push({
            provincia: listProvince[sigla],
            items: comuni[sigla]
          })
        }
        listComuni.sort((a, b) => ( a.provincia.localeCompare(b.provincia) ) )

        listComuni.unshift({
          provincia: '',
          items: [{
            id: -1,
            descrizione: 'Nessuno'
          }]
        })

        this.data.comuni = listComuni
      })
    },

    getDettaglioFornitore(id){
      // this.table.loading = true
      this.fornitoriService.getDettaglioFornitore(id).then((res) => {
        console.log(res.item)
        res.item.pagamenti.fatture.map((el) => {
          el.saldo = el.importo - el.pagato
          el.stato = ( (el.saldo == 0)? 'Chiuso': 'Aperto' )
        }) 

        this.data.item = res.item
        // title page browser
        document.title = 'info' in this.data.item ? ('ragsoc' in this.data.item.info ? document.title+" - "+  this.data.item.info.ragsoc : document.title) : document.title
        // this.table.loading = false
      })
    },

    getTipiAllegato(){
      this.utilityService.getTipiAllegato().then((res) => {
        this.data.tipiAllegato = res.items
      })
    },

    getTipiMetodoPagamento(){
      this.utilityService.getTipiMetodoPagamento().then((res) => {
        const tipiMetodiPagamento = res.items.map((el) => {
          return {
            id: el.id,
            descrizione: `${el.code} - ${el.name}`
          }
        })

        tipiMetodiPagamento.unshift({
          id: -1,
          descrizione: 'Nessuno'
        })

        this.data.metodiPagamento = tipiMetodiPagamento
      })
    },

    //////////////////////////////

    onAllegatiUpload() {
      this.$toast.add({severity: 'info', summary: 'Success', detail: 'Caricato allegato', life: 3000});
    },

    onEditInfo(){
      this.oldInfo = JSON.stringify(this.data.item.info)

      this.isInEdit = !this.isInEdit
    },

    onAbortInfoEdit(){
      this.data.item.info = JSON.parse(this.oldInfo)

      this.oldInfo = null
      this.isInEdit = !this.isInEdit
    },

    onUpdateInfo(){
      const allowed = [
        'ragsoc', 'codfis', 'piva', 'email', 'telefono', 'cellulare', 
        'toponimo', 'indirizzo', 'civico', 'cap', 'cod_comune', 
        'ultimofatturato', 'score', 'pregiudizi', 'cod_type_pay_mode'
      ]
      
      const info = Object.keys(this.data.item.info)
      .filter(key => allowed.includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: this.data.item.info[key]
        };
      }, {})

      if(info.cod_comune == -1){
        info.cod_comune = null
      }
      
      if( this.oldInfo != JSON.stringify(this.data.item.info) ) {
        this.fornitoriService.updateInfo(this.data.item.id, info).then((res) => {
          // console.log('UPDATED', res)
          if(res.success){
            delete res.item.id

            this.data.item.info = res.item
          }
        })
      }

      this.oldInfo = null
      this.isInEdit = !this.isInEdit
    }
  },

}
</script>

<style>

</style>
